import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import Icon from '../../components/AppIcon';
import HeroSection from './components/HeroSection';
import ProcessSection from './components/ProcessSection';
import IndependenceSection from './components/IndependenceSection';
// import ExpertReportsSection from './components/ExpertReportsSection';
import TestimonySection from './components/TestimonySection';
import EngagementSection from './components/EngagementSection';
import ReferencesSection from './components/ReferencesSection';

const LitigationSupport = () => {
  return (
    <>
      <Helmet>
        <title>Litigation Support - Northbridge Valuation & Advisory</title>
        <meta
          name="description"
          content="Court-qualified expert witness services and CVA-certified testimony for valuation disputes."
        />
        <meta name="keywords" content="expert witness, litigation support, court testimony, valuation disputes, CVA certified" />
        <link rel="canonical" href="/litigation-support" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />

        <main>
          <HeroSection />
          <ProcessSection />
          <IndependenceSection />
          {/* <ExpertReportsSection /> */}
          <TestimonySection />
          <EngagementSection />
          <ReferencesSection />
        </main>

        <Footer />
      </div>
    </>
  );
};

export default LitigationSupport;